import { render, staticRenderFns } from "./process-biz-route.vue?vue&type=template&id=55e9ea1e&"
import script from "./process-biz-route.vue?vue&type=script&lang=js&"
export * from "./process-biz-route.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports